/* eslint-disable */
/* eslint-disable consistent-return */
/* eslint-disable import/prefer-default-export */
import { ls } from '../LocalStorage';
import Env from '../env';
import Authorization from '../Authorization';
import {
  fetchWithXsrf,
  getRefreshVersion,
  refreshSessionIfNeeded,
  logoutOnce,
} from './SessionManager';

/**
 * Get common request headers.
 *
 * IMPORTANT:
 * No Authorization header is added.
 * Authentication is handled by the DICV_SESSION cookie.
 * DO NOT add Authorization/access token.
 */
const getHeaders = () => {
  const headers = {
    key: Env.env.REACT_APP_API_KEY,
  };

  const user = Authorization.getAuthUserId();
  const userRole = Authorization.getAuthUserRole();

  if (user) {
    headers.AuthUser = `${user}`;
  }

  if (userRole) {
    headers.Role = `${userRole}`;
  }

  return headers;
};

/**
 * FETCH DATA
 *
 * */
/* Shared session handling:
 *
 * Api.js
 *      |
 *      v
 * SessionManager
 *      |
 *      +---- XSRF synchronization
 *      |
 *      +---- Refresh synchronization
 *      |
 *      +---- Logout synchronization
 */
export const fetchData = async (url, config = {}, isRetry = false) => {
  /**
   * Capture the refresh version when this request starts.
   *
   * If another request refreshes the session before this
   * request handles its 401, we will not refresh again.
   */
  const requestRefreshVersion = getRefreshVersion();

  try {
    /**
     *
     * SEND REQUEST
     * 
     */
    const sendRequest = (xsrfToken) => {
      const headers = {
        ...getHeaders(),
        ...(config.headers || {}),
      };

      const method = (config.method || 'GET').toUpperCase();

      /**
       * XSRF token is required for state-changing requests.
       */
      if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
        if (xsrfToken) {
          headers['X-XSRF-TOKEN'] = xsrfToken;
        }
      }

      /**
       * Remove empty headers.
       */
      const sanitizedHeaders = Object.keys(headers).reduce((acc, key) => {
        const value = headers[key];

        if (value !== undefined && value !== null && String(value) !== '') {
          acc[key] = value;
        }

        return acc;
      }, {});

      /**
       * Cookie based authentication only.
       */
      delete sanitizedHeaders.Authorization;
      delete sanitizedHeaders.authorization;

      console.log('XSRF TOKEN:', xsrfToken ? 'present' : 'missing');
      console.log('IS RETRY:', isRetry);

      return fetch(url, {
        ...config,
        credentials: 'include',
        headers: sanitizedHeaders,
      });
    };

    /**
     * 
     * SHARED XSRF FLOW
     * 
     */
    const response = await fetchWithXsrf(sendRequest);

    const tokenExpirationTime = ls.getItem('expires_on') * 1 * 1000;

    /**
     * Auth status only for debugging.
     */
    const authStatus = response.headers.get('X-Auth-Status');

    let errorBody = null;

    if (response.status === 401) {
      try {
        errorBody = await response.clone().json();
      } catch (e) {
        errorBody = null;
      }
    }

    console.log(
      'URL:',
      url,
      response.status,
      authStatus,
      errorBody,
      tokenExpirationTime,
      Date.now()
    );

    /**
     *
     * 401 HANDLING
     * 
     *
     * Only refresh if:
     *
     * 1. Response is 401
     * 2. Session expiration has passed
     * 3. This is not already a retry
     */
    if (
      response.status === 401 &&
      Date.now() > tokenExpirationTime &&
      !isRetry
    ) {
      console.log('401 DETECTED AND SESSION EXPIRED');

      console.log('CALLING SHARED SESSION REFRESH');

      /**
       * Shared refresh.
       *
       * If another API is already refreshing:
       *
       *     API A -> refresh
       *     API B -> waits
       *     API C -> waits
       *
       * Only one refresh request is sent.
       */
      const refreshResult = await refreshSessionIfNeeded(requestRefreshVersion);

      console.log('REFRESH RESULT:', refreshResult);

      /**
       * 
       * REFRESH FAILED
       * 
       */
      if (!refreshResult || !refreshResult.ok) {
        console.error('SESSION REFRESH FAILED');

        console.error('LOGGING OUT USER');

        logoutOnce();

        return response;
      }

      /**
       * 
       * REFRESH SUCCESS
       * 
       */
      console.log('SESSION REFRESH SUCCESS');

      console.log('RETRYING ORIGINAL REQUEST');

      console.log('URL:', url);

      /**
       * Retry original request exactly once.
       */
      return fetchData(url, config, true);
    }

    /**
     * 
     * NORMAL RESPONSE
     * 
     */
    return response;
  } catch (error) {
    console.error('API REQUEST ERROR:', error);

    throw error;
  }
};
